import { useContext } from 'react';
import { CountryContext } from '~/context/i18n';

export const useLanguageUrl = () => {
  const { country, language } = useContext(CountryContext);
  return `/${country.code}/${language}/`;
};
